module.exports = __webpack_public_path__ + "img/suspend-pic-place.8baee981.png";